import React, { Component } from 'react';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import { hideModal, QBM_CLEAR_STATISTIC_FORM } from '../../../modules/modals';
import { clearStatistic } from './actions';


class ClearStatisticForm extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : QBM_CLEAR_STATISTIC_FORM});

  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "titleClearStatistic"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }


  submit = (e) => {
    e.preventDefault();

    const {clearStatistic, questionId} = this.props;

    clearStatistic(questionId)

    this.handleClose();

  }

  render() {
  
    const { zIndex } = this.props;
    const {formatMessage} = this.context;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          // onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              {/* <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div> */}
          </div>
          <div className="create-dialog-modal-content__body">
            <form className="create-dialog-form form-quiz-create" onSubmit={this.submit}>
              <div className="col-xs-12 text-center" style={{marginBottom: 20,}}>
                {formatMessage('txtStatisticClear')}
              </div>
              <div className="create-dialog-form__group flex"  style={{marginTop: 10}}>
                <button className="btn btn-success" type="button" onClick={() => {
                  this.handleClose();
                }}>{formatMessage('btnModalClearCancel')}</button>
                <button className="btn btn-warning" type="submit">{formatMessage('btnModalClearStatistic')}</button>
              </div>
            </form>
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
  hideModal,
  clearStatistic
}

export default connect(mapStateToProps, mapDispatchToProps)(ClearStatisticForm)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ClearStatisticForm/ClearStatisticForm.jsx